var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import ScalePricesToolTip from "../../components/scalepricetooltip.vue";
import { formatPrice, } from "../utilities/projecttable";
import { isNumber, } from "../utilities/wsi4_typeguards";
let MultiplicityElement = class MultiplicityElement extends Vue {
    constructor() {
        super(...arguments);
        this.multiplicity = 0;
        this.showScalePrices = false;
    }
    multiplicityChanged(e) { return e; }
    updateShowScalePrices(show) {
        if (!this.disabled) {
            this.showScalePrices = show;
        }
    }
    get elementKey() { return "multiplicity"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get invalid() { return this.multiplicity <= 0; }
    get priceArray() {
        return this.scalePrices.map(s => ({
            multiplicity: s.scaleValue,
            unitPrice: formatPrice(s.sellingPrice / s.scaleValue, this.networkBroker.configuration.priceFactors, this.i18n),
        }));
    }
    created() {
        if (!isNumber(this.value)) {
            throw Error("MultiplicityElement: Wrong type");
        }
        this.multiplicity = this.value;
    }
    onValueChanged(val, _oldVal) {
        if (!isNumber(val)) {
            return;
        }
        this.multiplicity = val;
    }
    onMultiplicityChanged(_val, _oldVal) {
        this.multiplicityChanged(this.multiplicity);
    }
};
__decorate([
    Prop({ required: true })
], MultiplicityElement.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], MultiplicityElement.prototype, "scalePrices", void 0);
__decorate([
    Prop({ required: true })
], MultiplicityElement.prototype, "enableScalePriceToolTip", void 0);
__decorate([
    Prop({ required: true })
], MultiplicityElement.prototype, "value", void 0);
__decorate([
    Inject()
], MultiplicityElement.prototype, "networkBroker", void 0);
__decorate([
    Inject()
], MultiplicityElement.prototype, "i18n", void 0);
__decorate([
    Emit()
], MultiplicityElement.prototype, "multiplicityChanged", null);
__decorate([
    Watch("value")
], MultiplicityElement.prototype, "onValueChanged", null);
__decorate([
    Watch("multiplicity")
], MultiplicityElement.prototype, "onMultiplicityChanged", null);
MultiplicityElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
            ScalePricesToolTip,
        },
        name: "MultiplicityElement",
    })
], MultiplicityElement);
export default MultiplicityElement;
